import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { type RootState } from "../../app/store";
import { setTaskStatus } from "../../components/layout/SnakebarSlice";
import { getCSVSmilesData, getSingleSmileData } from "./genfilApi";

interface stateType {
  status: "loading" | "failed" | "idle" | "succeeded";
  data: [];
}

const initialState: stateType = {
  status: "idle",
  data: [],
};

export const fetchSingleSmileData = createAsyncThunk(
  "genfil/fetchSingleSmileData",
  async (
    {
      smilesName,
    }: {
      smilesName: string;
    },
    { dispatch }
  ) => {
    try {
      dispatch(
        setTaskStatus({
          status: "pending",
          varient: "info",
          msg: "Genfil models running..",
          url: "",
          autoHideTime: 5000,
        })
      );
      const response = await getSingleSmileData({
        smilesName,
      });

      dispatch(
        setTaskStatus({
          status: "success",
          varient: "success",
          msg: "Genfil request finished successfully.",
          url: "/virtual-screening/genfil/visualize",
          autoHideTime: 30000,
        })
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        setTaskStatus({
          status: "error",
          varient: "error",
          msg: `${error?.response?.data?.detail || "Your request failed"}`,
          url: "",
          autoHideTime: 8000,
        })
      );
      throw error
    }
  }
);

export const fetchCSVSmilesData = createAsyncThunk(
  "genfil/fetchCSVSmilesData",
  async (
    {
      SMILESFile,
      smilesColumn,
    }: {
      SMILESFile: File;
      smilesColumn: string;
    },
    { dispatch }
  ) => {
    try {
      dispatch(
        setTaskStatus({
          status: "pending",
          varient: "info",
          msg: "Genfil models running..",
          url: "",
          autoHideTime: 5000,
        })
      );
      const response = await getCSVSmilesData({
        SMILESFile,
        smilesColumn,
      });

      dispatch(
        setTaskStatus({
          status: "success",
          varient: "success",
          msg: "Genfil request finished successfully.",
          url: "/virtual-screening/genfil/visualize",
          autoHideTime: 30000,
        })
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        setTaskStatus({
          status: "error",
          varient: "error",
          msg: `${error?.response?.data?.detail || "Your request failed"}`,
          url: "",
          autoHideTime: 8000,
        })
      );
      throw error;
    }
  }
);

const genfilSlice = createSlice({
  name: "genfilSlice",
  initialState,
  reducers: {
    setProperties(state, action) {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        fetchSingleSmileData.fulfilled,
        (state: stateType, action: any) => {
          state.data = action.payload.data;
          state.status = "succeeded";
        }
      )
      .addCase(fetchSingleSmileData.rejected, (state, action: any) => {
        state.status = "failed";
      })
      .addCase(fetchSingleSmileData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(
        fetchCSVSmilesData.fulfilled,
        (state: stateType, action: any) => {
          state.data = action.payload.data;
          state.status = "succeeded";
        }
      )
      .addCase(fetchCSVSmilesData.rejected, (state, action: any) => {
        state.status = "failed";
      })
      .addCase(fetchCSVSmilesData.pending, (state) => {
        state.status = "loading";
      });
  },
});

export const { setProperties } = genfilSlice.actions;
export const genfilProperties = (state: RootState) => state.genfil;
export default genfilSlice.reducer;
